import { computed, getCurrentInstance } from 'vue';
import useTranslate from '@/utilities/composables/useTranslate';
import useCustomIcon from '@/utilities/composables/useCustomIcon';
import { checkIsApple } from '@/utilities/isApple';

export default function useGHIntegrationCheck() {
  const _this = getCurrentInstance()?.proxy;
  if (!_this) return;

  const { translate } = useTranslate();
  const { iconPath } = useCustomIcon();

  const gitHubIntegrated = computed(() => {
    return _this.$store.getters.getIntegrationInstallations('github').length > 0;
  });

  const gitHubIntegratedObj = computed(() => {
    return gitHubIntegrated.value
      ? [
          {
            id: 'copyBranchName',
            label: translate('copyGitBranchName'),
            customIconName: iconPath('git-pull-request'),
            shortcutKey: [{ text: checkIsApple() ? '⌘' : 'Ctrl' }, { text: '⇧' }, { text: '.' }],
          },
        ]
      : [];
  });

  return {
    gitHubIntegratedObj,
  };
}
